let activeLocks = 0;

export function lockScroll() {
  if (typeof document === 'undefined') return;

  activeLocks += 1;
  document.body.classList.add('overflow-hidden');
}

export function unlockScroll() {
  if (typeof document === 'undefined') return;

  activeLocks = Math.max(0, activeLocks - 1);
  if (activeLocks === 0) {
    document.body.classList.remove('overflow-hidden');
  }
}
